var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSelectedBasketballratingIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "basketball"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.9982 24.6112L30.6316 20.9778C27.217 17.01 25.3411 11.9479 25.3455 6.71313C25.3455 6.18579 25.3655 5.65317 25.4024 5.1311C20.7279 5.4605 16.2833 7.28457 12.7251 10.3339L26.9982 24.6112Z",
    fill: "#1B51BB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.0246 18.5847L41.2712 10.3339C37.7646 7.32804 33.3952 5.51133 28.7911 5.14481C28.7479 5.66161 28.7236 6.18474 28.7236 6.71313C28.7193 11.0525 30.2419 15.2551 33.0246 18.5847Z",
    fill: "#1B51BB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.4114 20.9715C38.7406 23.7554 42.9432 25.2791 47.283 25.2756C47.8103 25.2756 48.3377 25.2514 48.8513 25.2081C48.4854 20.603 46.6687 16.2324 43.6622 12.7249L35.4114 20.9715Z",
    fill: "#1B51BB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5849 33.0244C15.2558 30.2404 11.0532 28.7166 6.71336 28.7202C6.18461 28.7202 5.66184 28.7427 5.14504 28.7877C5.5109 33.3929 7.32765 37.7635 10.3341 41.271L18.5849 33.0244Z",
    fill: "#1B51BB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.9982 29.3847L23.3648 33.0181C26.7793 36.9858 28.6552 42.048 28.6509 47.2827C28.6509 47.8101 28.6308 48.3427 28.5939 48.8648C33.2684 48.5356 37.7131 46.7115 41.2712 43.662L26.9982 29.3847Z",
    fill: "#1B51BB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.283 28.6506C42.0482 28.655 36.9861 26.7791 33.0183 23.3645L29.3849 26.9979L43.6622 41.271C46.7138 37.7136 48.5401 33.2689 48.8713 28.5937C48.3429 28.6306 47.8145 28.6506 47.283 28.6506Z",
    fill: "#1B51BB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.6114 26.9979L10.3341 12.7249C7.28231 16.2822 5.45596 20.7269 5.125 25.4022C5.65234 25.3653 6.17969 25.3452 6.70703 25.3452C11.9418 25.3409 17.0039 27.2168 20.9717 30.6313L24.6114 26.9979Z",
    fill: "#1B51BB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.7251 43.662C16.2318 46.6678 20.6011 48.4846 25.2052 48.8511C25.2495 48.3343 25.272 47.8115 25.2727 47.2827C25.2763 42.9429 23.7526 38.7403 20.9685 35.4112L12.7251 43.662Z",
    fill: "#1B51BB"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectedBasketballratingIcon);
export default __webpack_public_path__ + "static/media/selected_basketballrating_icon.7f85523e86c26454a546611343c143f8.svg";
export { ForwardRef as ReactComponent };